import React, { Fragment, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import RankingList from './RankingList'
import { Popover } from 'antd'
import { Button } from '@styles/button.style'
import { RankingPopupContent } from '@views/Popup/RankingPopup/index.style'
import AdvImg from '@components/AdvImg'
import rankingEventInfoIcon from '@assets/images/icon/ranking_event_icon/ranking_event_info.png'
import { isMobile } from 'react-device-detect'

const RankingPopup: React.FC = observer(() => {
  const { rankingEventStore, globalStore, authStore } = useRootStore()
  const { currentEvent, prevEventId, nextEventId, myRanking } = rankingEventStore
  const rankingImages = globalStore.getRankingImages()
  const { userInfo } = authStore

  const [bubbleVisible, setBubbleVisible] = useState(false)

  useOnMount(() => {
    const initFetch = async () => {
      await rankingEventStore.fetchRankingEvent()
    }
    initFetch().catch(console.error)
  })

  useEffect(() => {
    if (currentEvent) {
      rankingEventStore.fetchMyRanking(currentEvent.id)
    }
  }, [currentEvent, rankingEventStore])

  useOnUnmount(() => {
    rankingEventStore.reset()
  })

  const formatMonthDay = (date: Date) => {
    const parsedDate = new Date(date)

    const month = parsedDate.getMonth() + 1
    const day = parsedDate.getDate()

    return `${month}월 ${day}일`
  }

  const renderRankingImage = (url: string, alt: string) => {
    if (!url) return null
    return <img src={url} alt={alt} className="ranking-image" />
  }

  return (
    <RankingPopupContent>
      {renderRankingImage(rankingImages?.mainImage, '메인 이미지')}
      <section className="ranking-event">
        {currentEvent ? (
          <Fragment>
            <div className="ranking-event--header">
              <div className="title-wrap">
                <h3 className="ranking-event--title">{currentEvent.name}</h3>
                <p className="ranking-event--date-range">
                  {formatMonthDay(currentEvent.startDate)} ~ {formatMonthDay(currentEvent.endDate)}
                </p>
              </div>
              <button
                className="date-range-button prev-button"
                disabled={!prevEventId}
                onClick={() => rankingEventStore.fetchRankingEvent(prevEventId)}
                aria-label="이전 날짜"
              />
              <button
                className="date-range-button next-button"
                disabled={!nextEventId}
                onClick={() => rankingEventStore.fetchRankingEvent(nextEventId)}
                aria-label="이후 날짜"
              />
            </div>

            <RankingList eventId={currentEvent.id} isPending={currentEvent.isPending}/>

            <div className="my-ranking">
              <div className="my-ranking--left-section">
                <span className="my-ranking--rank">
                  {myRanking && myRanking.rank != null ? `${myRanking.rank}위` : '-'}
                </span>
                <span className="my-ranking--profile">
                  <AdvImg
                    src={userInfo?.avatar}
                    srcMode="small"
                    alt={userInfo.customProfileImg ? '사진첩 이미지' : '스킨'}
                    className="profile-image"
                  />
                </span>
                <span className="my-ranking--nick">{userInfo.nick}</span>
              </div>
              <span className="my-ranking--score">
                {myRanking && myRanking.score != null ? `${myRanking.score.toLocaleString()}점` : '-'}
              </span>
            </div>

            <div className="ranking-event--info">
              <p className="ranking-list-notice">※ 실시간 업데이트 됩니다.</p>
              <Popover
                visible={bubbleVisible}
                onVisibleChange={setBubbleVisible}
                placement="bottomRight"
                content={(
                  <div className="content">
                    <p className="formula">랭킹점수 = 기본점수 + 폴드배당 * 배당점수</p>
                    {currentEvent.condition && (
                      <p className="score">
                        기본점수 : {currentEvent.condition.baseScore}점, 배당점수 : {currentEvent.condition.oddsScore}점
                      </p>
                    )}
                  </div>
                )}
                trigger={isMobile ? 'click' : 'hover'}
                mouseLeaveDelay={0.05}
                overlayClassName="ranking-list-notice-popover"
                overlayStyle={{ position: 'fixed' }}
              >
                <Button className="score-calculator-button">
                  점수계산방법
                  <img src={rankingEventInfoIcon} alt="" className="score-calculator-button--icon"/>
                </Button>
              </Popover>
            </div>
          </Fragment>
        ) : (
          <Fragment></Fragment>
        )}
      </section>


      <section className="ranking-event-info">
        {/* 랭킹 보상, 이벤트 참여 안내, 유의사항 영역 - 어드민에서 등록 */}
        {renderRankingImage(rankingImages?.rewardImage, '보상 이미지')}
        {renderRankingImage(rankingImages?.rankingInfoImage, '랭킹 정보')}
        {renderRankingImage(rankingImages?.precautionsImage, '유의사항')}
      </section>
    </RankingPopupContent>
  )
})

export default RankingPopup
